import React from "react";
import {Helmet} from "react-helmet";
import {LeighFrancis} from "../../constants/meta";

export const A34Meta = () => (
    <Helmet>
        <title>Leigh Francis | Vieunite </title>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Leigh Francis"/>
        <meta name="twitter:description"
              content=". Channelling his signature comedic energy and formal artistic training, Leigh Francis captures a nostalgic pop culture spirit with vibrant imagination. "/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_leigh_francis.jpg"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Leigh Francis"/>
        <meta property="og:description"
              content=" Channelling his signature comedic energy and formal artistic training, Leigh Francis captures a nostalgic pop culture spirit with vibrant imagination. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ leigh_francis.jpg"/>


    </Helmet>);